
//Importaciones
import React from 'react'
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import CLabel from '../../../../Common/CLabel';
import { IconButton, mergeStyleSets, css, TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import DialogAction from './DialogAction';
import moment from 'moment';
import { useBoolean } from '@fluentui/react-hooks';
import { useState } from 'react';
import { isNullOrEmpty } from '../../../../../common/Helpers';


function GapActionCard(props) {
    //Helpers
    const { t } = useTranslation();

    //Parametros de entrada.
    const {
        inputParam_EditMode = null,
        inputParam_ActionItem = null,
        inputParam_GapElementId = null,
        inputParam_ShowSeparatorStyle = true,
        inputParam_SetterCauseActionList = null,
        inputParam_ShowCause = false,
        inputParam_ShowVariableName = false,
        inputParam_GapAnalyzeId = null,
        inputParam_GapRevisionId = null,
        inputParam_DataserieValueChartSelected = null,
        inputParam_SelectedCauses = [],
    } = props;

    //Parametros de componente.
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [selectedActionToDialog, setSelectedActionToDialog] = useState(null);

    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
    });
    //Funciones de componente.
    const onSelectActionToDialog = (action) => {
        setSelectedActionToDialog(action)
        showDialog()
    }
    //Render de componente.
    return  <Row className={`${inputParam_ShowSeparatorStyle ? 'border-bottom pt-0 ps-2' : ''}`}>
                <Col>
                    <Row>
                        <Col>
                            <CLabel labelText={ t('data-lang-lbl-enddate') } labelValue={ !isNullOrEmpty(inputParam_ActionItem.endDate) ? moment(inputParam_ActionItem.endDate).format("DD/MM/YYYY") : "" } />
                        </Col>
                        <Col>
                            <CLabel labelText={t('data-lang-lbl-status')} labelValue={ t(`data-lang-skaction-status${inputParam_ActionItem.statusId === 0 ? 1 : inputParam_ActionItem.statusId}`) }/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <CLabel labelText={t('data-lang-lbl-responsible')} labelValue={ inputParam_ActionItem.owner }/>
                        </Col>
                    </Row>
                    {
                        inputParam_ShowCause &&
                        <Row>
                            <Col>
                                <TooltipHost
                                    content={ inputParam_ActionItem.causeName }
                                    overflowMode={TooltipOverflowMode.Self}
                                    hostClassName={css(classNames.overflow)}
                                    onTooltipToggle={false}
                                    styles={{
                                        root: { display: 'block', width: "100%" },
                                    }}
                                >
                                    <b>{`${t('data-lang-lbl-cause')}`}</b>: {`${inputParam_ActionItem.causeName}`}
                                </TooltipHost>
                            </Col>
                        </Row>
                    }
                    <Row title={inputParam_ActionItem.action}>
                        <Col>
                            <CLabel labelText={t('data-lang-lbl-title')} labelValue={ inputParam_ActionItem.title }/>
                        </Col>
                    </Row>
                </Col>
                <Col className="col-auto my-auto">
                    <TooltipHost
                        content={ t('data-lang-btn-moredata') }
                        calloutProps={{ gapSpace: 0 }}
                        styles={{ root: { display: 'inline-block' } }}
                    >
                        <IconButton iconProps={{ iconName: 'View'  }} onClick={() => onSelectActionToDialog(inputParam_ActionItem)} />
                    </TooltipHost>
                </Col>
                {
                    selectedActionToDialog &&
                    <DialogAction
                        inputParam_GapElementId={inputParam_GapElementId}
                        inputParam_EditMode={inputParam_EditMode}
                        inputParam_IsDialogOpen={isDialogVisible}
                        inputParam_SetterIsDialogOpen={hideDialog}
                        inputParam_DialogEntity={selectedActionToDialog}
                        inputParam_SetterCauseActionList={inputParam_SetterCauseActionList}
                        inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                        inputParam_GapRevisionId={inputParam_GapRevisionId}
                        inputParam_DataserieValueChartSelected={inputParam_DataserieValueChartSelected}
                        inputParam_SelectedCauses={inputParam_SelectedCauses}
                    />
                }
            </Row>;
}

///Proptypes
GapActionCard.propTypes = {
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_ActionItem: PropTypes.object.isRequired,
    inputParam_ShowSeparatorStyle: PropTypes.bool.isRequired,
    inputParam_SetterCauseActionList: PropTypes.func,
    inputParam_ShowCause: PropTypes.bool,
    inputParam_GapAnalyzeId: PropTypes.number,
    inputParam_GapRevisionId: PropTypes.number,
    inputParam_DataserieValueChartSelected: PropTypes.number,
    inputParam_SelectedCauses: PropTypes.array,
};

export default GapActionCard;
